<script setup lang="ts">
import type { RouteLocationGeneric } from '#vue-router'

const seller = useSeller('server', 'retail')
const productCount = computed(() => helpers.toPositive(seller.seller.value?.productCount, 0))
const init = useInited('nav')
const init3 = useInited('init3')
const mobile = useMobile()

const t2 = useT2({
  Shops: 'Parduotuvės',
  'UAB LINAS LT All Rights Reserved.': 'Visos teisės saugomos UAB LINAS LT',
  'Privacy policy': 'Privatumo politika',
  'Cookie policy': 'Slapukų politika',
  'Copyright ©': '©',
  'Official Linas LT Online Store - Linen Manufacturer in Panevėžys, Lithuania Since 1957.': 'Oficiali Linas LT internetinė parduotuvė - lino gamintojas Panevėžyje, Lietuvoje nuo 1957 metų.',
})

/*

"Official e-commerce site of Linas LT – trusted linen products manufacturer based in Panevėžys, Lithuania since 1957.",
"Official Linas LT e-shop – linen manufacturer since 1957.",
"Linas LT Official Store – Linen Manufacturing Excellence Since 1957.".
"Gamintojo AB Linas elektroninė parduotuvė - linas.lt",
"Official Linas LT Online Store – Trusted Lithuanian Linen Manufacturer Since 1957."",
"Official Linas LT Online Shop – Trusted Lithuanian Linen Manufacturer Since 1957."",
"Official e-commerce site of Linas LT – trusted linen products manufacturer based in Panevėžys, Lithuania since 1957.""
"Official online shop of Linas LT – Trusted Linen Manufacturer Since 1957 based in Lithuanian, Panevezys"

"Official Linas LT Online Store - Linen Manufacturer Based in Panevėžys, Lithuania Since 1957."

Official Linas LT Online Store - Linen Manufacturer in Panevėžys, Lithuania Since 1957.

*/

const { myLink, linkPrivacy, linkCookiePolicy, linkTerms } = useLinks()

const linkTermsAll: {
  to: () => RouteLocationGeneric
  title: () => stringI18n
}[] = [
  { to: () => linkPrivacy(), title: () => t2('Privacy policy') },
  { to: () => linkTerms(), title: () => t2('Terms and conditions') },
  { to: () => linkCookiePolicy(), title: () => t2('Cookie policy') },
] as const

const copytext = computed(() => ts(t2('Copyright ©'), new Date().getFullYear(), t2('UAB LINAS LT All Rights Reserved.')))

const ui = computed(() => {
  const doc = seller.seller.value?.doc
  return {
    doc,
    handle: seller.handle.value,
    txt: doc?.footerTxt?.value,
  }
})

// const sellerLinks = [
//   [t2`Information`, { name: '@seller-info' }],
//   [t2`Size guide`, { name: '@seller-info-size-guide' }],
//   [t2`Shops`, { name: '@seller-info-shops' }],
//   [t2`Editorials`, { name: '@seller-editorial' }],
//   // [('Blog'), { name: '@seller-editorial-blog' }],
// ] as const

const sellerLinks = computed(() => {
  return [
    [t2('Products'), { name: 'search' }, 'Customer Care Information'],
    [t2('Customer Care'), { name: 'info' }, 'Customer Care Information'],
    [t2('About us'), { name: 'info-about' }],
    [t2('Shipping & Delivery'), { name: 'info-delivery' }],
    [t2('Returns & Refunds'), { name: 'info-returns' }],
    // [t2`Size guide`, { name: 'info-size-guide' }],
    [t2('Shops'), { name: 'info-shops' }],
    // [t2`Editorials`, { name: 'editorial' }],
    // [('Blog'), { name: 'editorial-blog' }],
  ] as const
})

const route = useRoute()
const locale = useLocale()
const { rewrite } = useLinks()

const languege = computed(() => {
  return STORE_LANGUAGES.map((lang) => {
    return {
      on: lang.iso === locale.value,
      lang,
      to: rewrite(route, lang.iso),
      aria: ts('Change language to', lang.name),
    }
  })
})

const clsFix = computed(() => (mobile.value ? 'min-height: 750px;' : 'min-height: 350px; width:95%'))
const clsFix2 = computed(() => (mobile.value ? '' : 'width:95%'))

const auth = updateUserDoc()
const initAuth = shallowRef(false)
const timerA = useTimeout()
watch(
  () => auth.user.value.isAuth,
  (auth) => timerA.set(() => (initAuth.value = !auth), 2000),
  { immediate: true }
)
</script>

<template>
  <div class="layout">
    <template v-if="init">
      <LazyAppNavigationMobile v-if="mobile" />
      <LazyAppNavigation v-else :product-count />
      <LazyAuthModal v-if="initAuth" />
    </template>

    <slot />

    <div class="m_pt140 d_pt6 d_pr1 d_pl1 m_pl04 m_pr04" :class="$clsClass('footer')">
      <div :class="[$style.footer, $clsClass('footer2')]" :style="clsFix">
        <div class="_col d_wm90ch">
          <b class="_fs34 _lh1 _pt1 _fw-xxxl">{{ ui.doc?.name }}</b>
          <div class="_short _fs09 _fw-l _pt1 m_pb1">{{ t2('Official Linas LT Online Store - Linen Manufacturer in Panevėžys, Lithuania Since 1957.') }}</div>
          <div :class="[$style.l, mobile ? '_col _align-start' : '_row']" class="_wrap _ctrY _ls-xs _fw-l _gap1 _pt1 _pb1">
            <LinkFalling v-for="[txt, to, aria] in sellerLinks" :key="txt" :to="ui.handle ? myLink(to.name, {}) : undefined" :txt :aria-label="aria" :alt="aria" />
          </div>

          <span v-if="ui.txt" class="_txt _ws_normal _pt2 _pb1">{{ ui.txt }}</span>

          <div class="_ctrY _row _gap1 _pt1 _mta">
            <NuxtLink
              v-for="item in languege"
              :key="item.lang.iso"
              :class="item.on && '_underline _fw-xl'"
              :aria-label="item.aria"
              :to="item.to"
              @click.prevent="$localeSync('from:footer', item.lang.iso)"
              >{{ item.lang.name }}</NuxtLink
            >
          </div>
        </div>

        <div class="m_hm300">
          <ProfileBox v-if="seller.seller.value?.doc?._uiProfile" seller social notitle subscribe :profile="seller.seller.value?.doc?._uiProfile" />
        </div>
      </div>
    </div>

    <footer class="_relative _row _wrap _spaced _fs09 _align-start _pt1 m_pl1 d_pl3 m_gap4 d_pr2 m_w100p _mta _c1 d_hm200 m_hm300" :style="clsFix2">
      <div :class="[mobile ? '_col _align-start' : '_row']" class="_pb4 _wrap _ctrY _fw-l _ls-xs _lw-l _gap1">
        <span>{{ copytext }}</span>
        <LinkFalling v-for="(item, index) in linkTermsAll" :key="index" :to="item.to()" :txt="item.title()" />
        <LinkUi to="https://linas.lt/" :txt="ts('linas.lt')" out target="_blank" external />
      </div>
      <LazyAppFooterIcons v-if="init3" />
    </footer>
  </div>
</template>

<style module>
.footer {
  composes: global(_fs09);

  composes: global(_pt3);
  composes: global(_pr1);
  composes: global(_pb3);
  composes: global(m_pl1);
  composes: global(d_pl2);

  composes: global(d_gap4);
  composes: global(m_gap2);

  composes: global(m_br14);
  composes: global(d_br22);

  composes: global(_flexblock);
  composes: global(m_col);
  composes: global(_spaced);
  composes: global(_shadow);

  composes: global(_c0);

  --g-p1: -42px -44px;
  --g-p2: 25px 15px;
  --g-p4: -30px 10px;
  --g-p5: 80px 199px;
  --g-c1: 250;
  --g-c2: 215;
  --g2-s2: 25%;
  --g2-l2: 40%;
  --g3-l: 12%;
  --g3-s: 80%;

  background:
    radial-gradient(farthest-side, hsl(var(--g-c2), var(--g3-s), var(--g3-l)) 10%, #fff0 80%) 122px -310px,
    radial-gradient(hsl(var(--g-c1), var(--g3-s), var(--g3-l)) 10%, #fff0 70%) var(--g-p1),
    radial-gradient(hsl(var(--g-c1), var(--g3-s), var(--g3-l)) 10%, #fff0 50%) var(--g-p2),
    radial-gradient(hsl(var(--g-c2), var(--g3-s), var(--g3-l)) 20%, #fff0 90%) -30px -91px,
    radial-gradient(hsl(var(--g-c2), var(--g3-s), var(--g3-l)) 20%, #fff0 110%) var(--g-p4),
    radial-gradient(hsl(var(--g-c1), var(--g3-s), var(--g3-l)) 15%, #fff0 90%) var(--g-p5),
    radial-gradient(hsl(var(--g-c1), var(--g3-s), var(--g3-l)) 20%, #fff0 100%) -5px 7px,
    hsl(var(--g-c2), var(--g3-s), var(--g3-l));
}
</style>
